export enum DesifModuloEnum {

  MODULO_1 = "Demonstrativo Cont�bil",
  MODULO_2 = "Apura��o Mensal do ISSQN",
  MODULO_3 = "Informa��es Comuns aos Munic�pios",
  MODULO_4 = "Demonstrativo das Partidas dos Lan�amentos Cont�beis"
}
